import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { environment } from '@env/environment';
import { AuthenticationService } from './services/authentication.service';
import { User } from './models/user';
import { Subject, pipe, merge, Subscription } from 'rxjs';
import { filter, first, takeUntil } from 'rxjs/operators';
import { ALNIdentityAuthService } from './auth/aln-identity-auth.service';

@Component({
    selector: 'redirect',
    template: '<div fxLayout="row" fxLayoutAlign="space-around center" style="width:100%;height:100%"><mat-spinner diameter="50" strokeWidth="5"></mat-spinner></div>'
})
export class AppGatewayComponent implements OnInit, OnDestroy {

    currentUser: User;
    landingPage: string;
    private _unsubscribeAll: Subscription[] = [];

    constructor(
        private route: ActivatedRoute,
        private authenticationService: AuthenticationService,
        private alnIdentityAuthService: ALNIdentityAuthService,
        private router: Router) { }

    ngOnDestroy(): void {
        this._unsubscribeAll.forEach(subscription => subscription.unsubscribe());
    }

    ngOnInit(): void {
        if (window.location.href.indexOf('code') === -1 && !this.alnIdentityAuthService.isAuthorized) {
            this.alnIdentityAuthService.login();
        }

        this.router.events.pipe(first(e => e instanceof NavigationEnd))
            .subscribe(nav => {
                const sub = this.alnIdentityAuthService.authorized$
                    .pipe(filter(authorized => !!authorized))
                    .subscribe((auth) => {
                        this.currentUser = this.alnIdentityAuthService.user;
                        this.landingPage = this.route.snapshot.params['landingpage'];

                        const redirectUri = localStorage.getItem('redirect');
                        if (!!redirectUri) {
                            localStorage.removeItem('redirect');
                            this.router.navigateByUrl(redirectUri);
                            return;
                        }

                        if (!this.authenticationService.eFilingSettings)
                            this.authenticationService.getSettingsFrmAPI().subscribe(() => {
                                this.redirect();
                            })
                        else
                            this.redirect();
                    });
                this._unsubscribeAll.push(sub);
            });
    }

    redirect() {
        const dashboard = this.route.snapshot.queryParams.dashboard;
        const orderNumber = this.route.snapshot.queryParams.orderNumber;
        const caseNumber = this.route.snapshot.queryParams.caseNumber;

        if (!this.landingPage || this.landingPage === 'home') {
            this.router.navigate(['/dashboard']);
        }
        else if (this.landingPage === 'mail') {
            window.location.href = `${environment.centralAppBaseUri}/apps/appgateway/${this.currentUser.userId}/mail`;
        }
        else if (this.landingPage === 'calendar') {
            window.location.href = `${environment.centralAppBaseUri}/apps/appgateway/${this.currentUser.userId}/calendar`;
        }
        else if (this.landingPage === 'new-filing' || this.landingPage === 'subsequent') {
            const efilingRedirectURL = this.authenticationService.eFilingSettings.find(x => x.key == 'EFilingOCAppBaseUri').defaultValue;
            const landing = this.landingPage.includes('subsequent') ? '/subsequent/filing' : '/new-filing';
            if (dashboard == "OC") {
                if (caseNumber) {
                    window.location.href = `${efilingRedirectURL + landing}?caseNumber=${caseNumber}`;
                }
                else {
                    window.location.href = `${efilingRedirectURL + landing}?orderNumber=${orderNumber}`;
                }
            }
            else//LA 
            {
                if (caseNumber) {
                    this.router.navigate([this.landingPage.includes('subsequent') ? `/subsequent/filing/case/${caseNumber}` : `/new-filing/${orderNumber}`], { relativeTo: this.route });
                }
                else {
                    this.router.navigate([this.landingPage.includes('subsequent') ? `/subsequent/filing/${orderNumber}` : `/new-filing/${orderNumber}`], { relativeTo: this.route });
                }
            }
        }
    }
}
